import { Fragment, useEffect, useState, useContext } from 'react';
import { Row, Col } from 'react-bootstrap';
import { PermintaanBahanProduksiApi } from 'api';
import { TableTransferBahanProduksi } from '../TableTransferBahanProduksi';
import { TablePermintaanPW } from './TablePermintaanPW';
import { TransferBahanProduksiContext } from '../../Context';

export const TabPlywood = () => {
  const { dataJobOrder, dataPermintaan } = useContext(
    TransferBahanProduksiContext
  );
  const id_permintaan_produksi = dataJobOrder.id_permintaan_produksi;
  const [history, setHistory] = useState([]);

  // FETCH HISTORY
  useEffect(() => {
    if (id_permintaan_produksi) {
      PermintaanBahanProduksiApi.transfer({
        id_permintaan_produksi,
        ref_bahan: 'bpw',
      })
        .then((res) => setHistory(res.data.data ?? []))
        .catch(({ response }) =>
          alert(`Gagal memuat data History Plywood ${response.data.message}`)
        );
    }
  }, []);

  return (
    <Fragment>
      <Row className="d-flex justify-content-between align-items-end mb-1">
        <Col>
          <small>List Data Permintaan Plywood</small>
        </Col>
      </Row>
      <TablePermintaanPW data={dataPermintaan?.plywood ?? []} />

      <small className="mt-2">List Data Transfer Bahan Produksi</small>
      <TableTransferBahanProduksi
        tipe="editable"
        tipeTransfer="plywood"
        data={dataPermintaan?.plywood}
        uniqueKey="id_permintaan_produksi_plywood"
      />

      <small className="mt-2">History Transfer Bahan Produksi</small>
      <TableTransferBahanProduksi tipe="readonly" data={history} />
    </Fragment>
  );
};
